import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "../features/auth/authSlice";
import fipReducer from "../features/fip/fipSlice";
import accountReducer from "../features/account/accountSlice";
import consentReducer from "../features/consent/consentSlice";
import secondaryReducer from "../features/secondaryNumber/secondarySlice";
import uiReducer from "../features/ui/uiSlice";

const rootReducer = combineReducers({
    auth: authReducer,
    fip: fipReducer,
    account: accountReducer,
    consent: consentReducer,
    secondaryNumber: secondaryReducer,
    ui: uiReducer,
});

export default rootReducer;
